import { AccessLog } from './identity/access-log.model';
export interface GetAccessLogsResponse {
    results: Array<AccessLog>;
    size: number;
    pages: number;
    next: number;
    prev: number;
}

export type Esito = 'OK' | 'KO';
export const Esito = {
    Ok: 'OK' as Esito,
    Ko: 'KO' as Esito
}

export interface GenericResponse {
    esito: Esito;
    messaggio: string;
    result: any;
}

export interface GenericErrorResponse extends GenericResponse {

    result: ErrorResponse;
}

export interface ErrorResponse {

    error_code: string;
    error_desc: string;
    serialization_errors?: Object
}
